var OptionList = kendo.toolbar.Item.extend({
	init: function (options, toolbar) {
		this.options = options;
		this.toolbar = toolbar;

		//build kendoDropDownList from the provided options in ToolBar configuration
		var dropDownList = $("<select />").kendoDropDownList({
			height: "auto",
			dataTextField: "text",
			dataValueField: "value",
			optionLabel: options.text, //use tool's text as option label
			change: $.proxy(this._change, this), //do something on change
			dataSource: options.list
		}).data("kendoDropDownList");

		this.dropDownList = dropDownList;
		this.element = dropDownList.wrapper;


		//the following methods add attributes in the HTML that are used for the resizable functionality
		this.attributes();
		this.addUidAttr();
		this.addOverflowAttr();

		console.log(options.id);
		$(dropDownList.wrapper).closest('.k-widget').data('test', options.id);
		console.log($(dropDownList.wrapper).closest('.k-widget'));
	},
	_change: function (e) {
		this.options.change(e.sender.value());
	}
});

//Overflow tool - inherits from the existing tool
var OptionDialog = kendo.toolbar.OverflowButton.extend({
	init: function (options, toolbar) {
		kendo.toolbar.OverflowButton.fn.init.call(this, options, toolbar);

		this.options = options;
		this.element.on("click", $.proxy(this._click, this)); //open the dialog on click

		this._dialog(); //build dialog
		this._listView(); //build listView
	},
	_dialog: function () {
		this.dialog = $("<div />", {html: "<div class='k-list'></div>"}).kendoWindow({
			title: this.options.text,
			width: 280,
			height: 220
		}).data("kendoWindow");
	},
	_listView: function () {
		this.listView = this.dialog.element.find("div").kendoListView({
			dataSource: this.options.list,
			template: "<div class='k-item'>#= text #</div>",
			selectable: true,
			change: $.proxy(this._change, this) //do something when item is selected
		}).data("kendoListView");
	},
	open: function () {
		this.dialog.open();
	},
	_change: function (e) {
		var listView = e.sender;
		var dataItem = listView.dataSource.getByUid(listView.select().data("uid"));
		this.options.change(dataItem.value);
	},
	_click: function () {
		this.open();
	}
});

export function registerKendoToolbarOptionList() {
	kendo.toolbar.registerComponent("optionList", OptionList, OptionDialog);
}

